var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V226H496V16Z",
    fill: "#2980B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 226H16V286H496V226Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 286H16V496H496V286Z",
    fill: "#2980B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.929 390.202L165.695 375.461L164.927 402.127L153.043 378.243L139.046 400.953L140.695 374.327L117.218 386.996L131.959 364.762L105.293 363.994L129.177 352.11L106.467 338.112L133.093 339.762L120.424 316.285L142.658 331.026L143.426 304.36L155.31 328.243L169.308 305.534L167.658 332.16L191.135 319.491L176.394 341.725L203.06 342.493L179.177 354.377L201.886 368.374L175.26 366.725L187.929 390.202Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNr);
export default __webpack_public_path__ + "static/media/NR.0b7971690e1d3a1774d933c1d7313cfd.svg";
export { ForwardRef as ReactComponent };